module.exports = __webpack_public_path__ + "static/media/10.feb26f13.jpg";